import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, Manager } from "../store_types"
import { callSalesAPI } from "../../api/managers"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    salesManagers : []
  }
}

const managers = {
  state: () => getDefaultState(),

  getters: {
    salesManagers (state : State) {
      return state.salesManagers
    },
  },

  actions: {
    fetchSalesManagers({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | Array<Manager>) => void, getters: { [authHeaders: string]: AuthHeaders }}){
      return new Promise<void>((resolve, reject) => {
        callSalesAPI(
          getters.authHeaders,
          // Success
          (headers: AxiosResponseHeaders, salesManagers: Array<Manager>) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_SALES_MANAGERS, salesManagers)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
    resetManagersState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_MANAGERS_STATE)
    },
  },
  mutations: {
    [MutationTypes.ASSIGN_SALES_MANAGERS](state: State, salesManagers: Array<Manager>) {
      state.salesManagers = salesManagers
    },
    [MutationTypes.RESET_MANAGERS_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default managers
